module.exports = __webpack_public_path__ + "img/2_izbove.5cfc51e8.jpg";